export default __webpack_public_path__ + "static/media/san-rafael-10.560fc962.jpg";